import { Component, OnInit, OnDestroy } from "@angular/core";
//import { Subscription } from 'rxjs';

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { SchoolService } from "../../../shared/services/school.service";
import { UserService } from "../../../shared/services/user.service";

import { DataService_InfractionMaintenanceSBT } from "./shared/data.service";
import { SchoolInfo } from "./shared/SchoolInfo";
import { wsInfractionMaintenanceInfractionInfo } from "./shared/wsInfractionMaintenanceInfractionInfo";
import { wsInfractionMaintenanceToggleActiveParm } from "./shared/wsInfractionMaintenanceInfractionInfo";
import { wsInfractionMaintenanceToggleBasicParm } from "./shared/wsInfractionMaintenanceInfractionInfo";

import { AddEditInfractionSBTComponent } from "./addeditinfractionsbt/addeditinfractionsbt.component";

import { ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-root",
	templateUrl: "./infractionmaintenancesbt.component.html",
	styleUrls: ["./infractionmaintenancesbt.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class InfractionMaintenanceSBTComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterActiveDesc", { static: false })
	public filterActiveDesc: Dropdown;
	@ViewChild("filterIsBasicModeDesc", { static: false })
	public filterIsBasicModeDesc: Dropdown;
	@ViewChild("filterSchoolsDesc", { static: false })
	public filterSchoolsDesc: Dropdown;
	@ViewChild("filterDefinedByDesc", { static: false })
	public filterDefinedByDesc: Dropdown;

	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_InfractionMaintenanceSBT,
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	//	Infraction List
	public lstInfraction: wsInfractionMaintenanceInfractionInfo[] = [];
	public SelectedInfraction: wsInfractionMaintenanceInfractionInfo;

	//	Filters
	public lstActiveDescs: any = [];
	public lstIsBasicModeDescs: any = [];
	public lstSchoolsDescs: any = [];
	public lstDefinedByDescs: any = [];
	public lstInfractionLevelDescs: any = [];

	//	Infraction Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		// this.LoadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID > 0) {
			this.isBusy = true;
			this.dataService
				.InfractionMaintenanceInfractionSelectList(this.SelectedSchool.SchoolID)
				.subscribe((data) => this.InfractionMaintenanceInfractionSelectList_Complete(data));
		} else {
			this.lstInfraction = [];
			this.SelectedInfraction = null;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceInfractionSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceInfractionSelectList_Complete(data: any) {
		this.SelectedInfraction = null;
		this.lstInfraction = data;

		//
		//	Set Filter Lists
		//
		this.lstActiveDescs = Array.from(new Set(this.lstInfraction.map((item: any) => item.ActiveDesc))).sort();
		this.lstIsBasicModeDescs = Array.from(new Set(this.lstInfraction.map((item: any) => item.IsBasicModeDesc))).sort();
		this.lstSchoolsDescs = Array.from(new Set(this.lstInfraction.map((item: any) => item.SchoolsDesc))).sort();
		this.lstDefinedByDescs = Array.from(new Set(this.lstInfraction.map((item: any) => item.DefinedByDesc))).sort();
		this.lstInfractionLevelDescs = Array.from(new Set(this.lstInfraction.map((item: any) => item.InfractionLevelDesc))).sort();

		//
		//	Set Filter Defaults
		//
		this.onSetFilterDefaults();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "InfractionLevelID", order: 1 });
		this.mydt.multiSortMeta.push({ field: "InfractionDesc", order: 1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetFilterDefaults
	//
	//-----------------------------------------------------------------------------------------------------
	onSetFilterDefaults() {
		this.mydt.filters.ActiveDesc["value"] = "Yes"; // Default To 'Yes'
		this.mydt.filters.IsBasicModeDesc["value"] = null; // Default To 'Any'
		this.mydt.filters.SchoolsDesc["value"] = null; // Default To 'Any'
		this.mydt.filters.DefinedByDesc["value"] = null; // Default To 'Any'
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleActive() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		if (this.SelectedInfraction == null) {
			this.ErrorMessage = "Please select an infraction to toggle active status.";
			return;
		}

		if (this.SelectedInfraction.DefinedByID == 4 && this.user.UserLevelID != 1) {
			this.ErrorMessage = "Only district level users can toggle Active status on district level infractions.";
			return;
		}

		if (this.SelectedInfraction.DefinedByID == 1 || this.SelectedInfraction.DefinedByID == 2) {
			// System or Import
			this.ErrorMessage = "You cannot toggle Active status on System or Import level infractions.";
			return;
		}

		let parm: wsInfractionMaintenanceToggleActiveParm = {
			UserID: this.user.userID,
			InfractionID: this.SelectedInfraction.InfractionID,
		};

		this.isBusy = true;
		this.dataService.InfractionMaintenanceToggleActive(parm).subscribe((data) => this.InfractionMaintenanceToggleActive_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceToggleActive_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceToggleActive_Complete(data: any) {
		this.ErrorMessage = data[0];
		this.isBusy = false;

		//
		//	Refresh Q
		//
		if (this.ErrorMessage.length == 0) {
			this.onRefresh();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleBasic
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleBasic() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		if (this.SelectedInfraction == null) {
			this.ErrorMessage = "Please select an infraction to toggle Basic status.";
			return;
		}

		if (this.SelectedInfraction.Active == false) {
			this.ErrorMessage = "You cannot toggle Basic status on inactive infractions.";
			return;
		}

		let parm: wsInfractionMaintenanceToggleBasicParm = {
			UserID: this.user.userID,
			InfractionID: this.SelectedInfraction.InfractionID,
			SchoolID: this.SelectedSchool.SchoolID,
		};

		this.isBusy = true;
		this.dataService.InfractionMaintenanceToggleBasic(parm).subscribe((data) => this.InfractionMaintenanceToggleBasic_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	InfractionMaintenanceToggleBasic_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	InfractionMaintenanceToggleBasic_Complete(data: any) {
		this.ErrorMessage = data[0];
		this.isBusy = false;

		//
		//	Refresh Q
		//
		if (this.ErrorMessage.length == 0) {
			this.onRefresh();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowDblClick
	//
	//-----------------------------------------------------------------------------------------------------
	onRowDblClick(item: any) {
		this.onEdit();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEdit
	//
	//-----------------------------------------------------------------------------------------------------
	onEdit() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		if (this.SelectedInfraction == null) {
			this.ErrorMessage = "Please select an infraction to edit.";
			return;
		}

		if (this.SelectedInfraction != null && this.SelectedInfraction.InfractionID > 0) {
			let popup_header = "Edit Infraction";

			var ref = this.dialogService.open(AddEditInfractionSBTComponent, {
				header: popup_header,
				width: "880px",
				data: {
					UserID: this.user.userID,
					UserLevelID: this.user.UserLevelID,
					SchoolID: this.SelectedInfraction.SchoolID,
					InfractionID: this.SelectedInfraction.InfractionID,
					isAdd: false,
				},
			});

			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAdd
	//
	//-----------------------------------------------------------------------------------------------------
	onAdd() {
		this.ErrorMessage = "";

		if (this.SelectedSchool.SchoolID < 1) {
			this.ErrorMessage = "Please select a school..";
			return;
		}

		let popup_header = "Add Infraction";

		var ref = this.dialogService.open(AddEditInfractionSBTComponent, {
			header: popup_header,
			width: "880px",
			data: {
				UserID: this.user.userID,
				UserLevelID: this.user.UserLevelID,
				SchoolID: this.SelectedSchool.SchoolID,
				InfractionID: -1,
				isAdd: true,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response == 1) {
				//
				//	Refresh Q
				//
				this.onRefresh();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedInfraction here. We don't unselect when selected.
		//
		this.SelectedInfraction = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;
				let isSchoolSelected: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
						isSchoolSelected = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
							isSchoolSelected = true;
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}

				this.isBusy = false;

				if (isSchoolSelected == true) {
					this.onRefresh();
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
